import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Stack, Typography } from '@mui/material';

import { useRouter } from '@cvt/routing';

import { FullscreenLayout } from '@shared/components/layouts/FullscreenLayout';
import { DirigoShortLogo } from '@shared/components/Logo/DirigoShortLogo';
import { AltLogoText } from '@shared/components/Logo/AltLogoText';


export const Welcome = () => {
  const router = useRouter();

  return (
    <FullscreenLayout
      bgcolor="#004b66"
      sx={{
        backgroundImage: 'radial-gradient(ellipse at top,hsl(196 80% 25%) 0%,transparent 60%)',
      }}
    >
      <Background/>
      <Box height="100%" display="flex" flexDirection="column" justifyContent="center" position="relative" zIndex={1}>
        <Container maxWidth="sm" color="white">
          <Stack spacing={4} justifyContent="center" textAlign="center">
            <Box height={64}>
              <DirigoShortLogo/>
            </Box>
            <Typography variant="h1" fontWeight={700} fontSize={36} color="white">
              <AltLogoText/>
            </Typography>
            <Typography variant="body2" color="textSecondary" fontSize={18} sx={{ color: '#ffffffb3' }}>
              Where leaders forge intentional stories from lived experience.
            </Typography>
            <Box>
              <Button
                component={RouterLink}
                to={router.auth.login.path}
                variant="contained"
                color="primaryAlt"
                size="large"
                sx={{ px: 6 }}
              >
                Begin
              </Button>
            </Box>
          </Stack>
        </Container>
      </Box>
    </FullscreenLayout>
  );
};

const Background = () => {
  return (
    <>
      <Box
        position="absolute"
        height="100%"
        sx={{
          inset: 0,
          backgroundImage: 'radial-gradient(ellipse at top,hsl(196 80% 25%) 0%,transparent 60%)',
        }}
      />
      <Box
        position="absolute"
        height="100%"
        sx={{
          inset: 0,
          backgroundImage: 'radial-gradient(ellipse at bottom right,hsl(34 86% 55%/.06) 0%,transparent 50%)',
        }}
      />
    </>
  );
};